import React, { useState, useRef, useEffect } from "react";
import { BlockMath, InlineMath } from "react-katex";
import "katex/dist/katex.min.css";
import InfoIcon from '@mui/icons-material/Info';
import { Tooltip } from "@mui/material";

const EditQuestionMathModal = ({ isOpen, onClose, mathExpEdit, handleInputChange, handleArrayChange }) => {
    const [latexInput, setLatexInput] = useState("");
    const inputRef = useRef(null);
    useEffect(() => {
        console.log("mathExpEditFirst ", mathExpEdit);
        setLatexInput(mathExpEdit.text)
    }, [mathExpEdit]);

    if (!isOpen) return null;

    const insertLatex = (latex, cursorOffset = 0) => {
        const input = inputRef.current;
        if (!input) return;

        const startPos = input.selectionStart;
        const endPos = input.selectionEnd;
        const newValue = latexInput.substring(0, startPos) + " " + latex + latexInput.substring(endPos);

        setLatexInput(newValue);

        const newCursorPos = startPos + latex.indexOf("{}") + cursorOffset + 2;
        setTimeout(() => input.setSelectionRange(newCursorPos, newCursorPos), 10);
        input.focus();
    };

    const savehandler = (e) => {
        try {
            e.target.value = latexInput;
            console.log(latexInput,"latexInput");
            console.log(mathExpEdit,"mathExpEdit");
            if (mathExpEdit.for === 'question') {
                console.log('check 1');
                handleInputChange(e, mathExpEdit.language, mathExpEdit.for);
            } else if (mathExpEdit.for === 'options') {
                console.log('check 2');
                handleArrayChange(e, mathExpEdit.language, mathExpEdit.for, mathExpEdit.index)
            }
            onClose()
        } catch (error) {
            console.log(error);
        }
    };

    const renderMixedContent = () => {
        let inputStr = typeof latexInput == "string" ? latexInput :(String(latexInput));
        let parts = inputStr.split(/(\$[^$]+\$)/g);
        return parts.map((part, index) => {
            if (part.startsWith("$") && part.endsWith("$")) {
                let modifiedPart = part.replace(/\$/g, "");
                return <InlineMath key={index} math={modifiedPart} />;
            }
            return <span key={index}>{part}</span>;
        });
    };
    const infoText = "Wrap math expressions with $...$ symbols. Use $...$ for inline math expressions (e.g., $\\sqrt{a + b}$). Use { } to insert variables. Click on the symbols below to insert them easily.";


    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <h2 style={styles.title}><span></span>
                  <span>
                    Edit Math Expression
                        <Tooltip title={infoText}>
                    <InfoIcon style={{marginLeft:'5px'}}/>
                        </Tooltip>
                    </span>  
                    <button
                        type='button'
                        className='close'
                        onClick={onClose}
                        style={{
                            color: '#fff',
                            fontSize: '24px',
                            border: 'none',
                            background: 'none',
                            cursor: 'pointer',
                        }}
                    >
                        &times;
                    </button></h2>
                <input
                    ref={inputRef}
                    type="text"
                    value={latexInput}
                    onChange={(e) => setLatexInput(e.target.value)}
                    placeholder="Enter LaTeX here..."
                    style={styles.inputBox}
                />
                <div style={styles.previewBox}>{latexInput ? renderMixedContent() : <div style={{ fontSize: '18px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold' }} >Preview Here</div>}</div>

                <div style={styles.keyboardContainer}>
                    {[
                        // Arithmetic Operators
                        { label: "+", latex: "+" },
                        { label: "-", latex: "-" },
                        { label: "×", latex: "\\times" },
                        { label: "÷", latex: "\\div" },
                        { label: "=", latex: "=" },
                        { label: "≠", latex: "\\neq" },
                        { label: "≤", latex: "\\leq" },
                        { label: "≥", latex: "\\geq" },

                        // Exponents & Fractions
                        { label: "x²", latex: "x^{2}", offset: 3 },
                        { label: "Denominator", latex: "_{}", offset: 1 },
                        { label: "Exponent", latex: "^{}", offset: 1 },
                        { label: "Fraction", latex: "\\frac{}{}", offset: 1 },
                        { label: "√ Square Root", latex: "\\sqrt{}", offset: 1 },

                        // Trigonometry
                        { label: "sin", latex: "\\sin{}", offset: 1 },
                        { label: "cos", latex: "\\cos{}", offset: 1 },
                        { label: "tan", latex: "\\tan{}", offset: 1 },

                        // Greek Letters
                        { label: "π", latex: "\\pi" },
                        { label: "θ", latex: "\\theta" },
                        { label: "α", latex: "\\alpha" },
                        { label: "β", latex: "\\beta" },
                        { label: "γ", latex: "\\gamma" },

                        // Calculus & Sets
                        { label: "∫ Integral", latex: "\\int_{}^{}", offset: 5 },
                        { label: "∑ Sum", latex: "\\sum_{}^{}", offset: 5 },
                        { label: "∞ Infinity", latex: "\\infty" },
                        { label: "log", latex: "\\log_{}", offset: 1 },

                        // Degree, Modulus & Division
                        { label: "° Degree", latex: "^{\\circ}", offset: 3 },
                        { label: "Modulus", latex: "|x|", offset: 1 },
                        { label: "Division (a/b)", latex: "\\frac{a}{b}", offset: 4 },

                        // Additional symbols
                        { label: "∈", latex: "\\in" },
                        { label: "∉", latex: "\\notin" },
                        { label: "∪ Union", latex: "\\cup" },
                        { label: "∩ Intersection", latex: "\\cap" },
                    ].map((btn, index) => (
                        <button key={index} style={styles.button} onClick={() => insertLatex(btn.latex, btn.offset || 0)}>
                            {btn.label}
                        </button>
                    ))}
                </div>

                <div style={styles.actionButtons}>
                    <button style={{ ...styles.actionButton, backgroundColor: "#28a745" }} onClick={savehandler}>
                        Save
                    </button>

                    <button style={{ ...styles.actionButton, backgroundColor: "#dc3545" }} onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

const styles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    modal: {
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
        width: "90%",
        maxWidth: "500px",
        textAlign: "center",
    },
    title: {
        fontSize: "20px",
        fontWeight: "bold",
        marginBottom: "15px",
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    inputBox: {
        width: "100%",
        padding: "10px",
        fontSize: "16px",
        border: "2px solid #007bff",
        borderRadius: "8px",
        textAlign: "center",
        outline: "none",
    },
    previewBox: {
        marginTop: "15px",
        minHeight: "50px",
        background: "#f8f9fa",
        padding: "10px",
        borderRadius: "6px",
        fontSize: "18px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    keyboardContainer: {
        display: "flex",
        flexWrap: "wrap",
        gap: "8px",
        justifyContent: "center",
        marginTop: "20px",
    },
    button: {
        padding: "8px 10px",
        fontSize: "14px",
        backgroundColor: "#007bff",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        transition: "background 0.3s",
    },
    actionButtons: {
        marginTop: "15px",
        display: "flex",
        justifyContent: "center",
        gap: "10px",
    },
    actionButton: {
        padding: "10px 14px",
        fontSize: "14px",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        transition: "background 0.3s",
    },
};

export default EditQuestionMathModal;
